import React, { Component } from "react";
import styles from "./InfoList.css";
import { TypeInfoList, TypeRoute } from "../../constants/consts-prop-types";
import InfoListItem from "./InfoListItem/InfoListItem";

class InfoList extends Component {
  static propTypes = {
    currentRoute: TypeRoute,
    data: TypeInfoList,
  };

  static numItemsPerPage = 8;

  render() {
    const params = new URLSearchParams(document.location.search);
    const { items, title } = this.props.data;
    const backgroundImage = `url(${params.get("image")})`;

    const lang =
      document.documentElement.lang.length > 2
        ? "da"
        : document.documentElement.lang;

    return (
      <div className={styles.InfoList}>
        <div
          className={styles.backgroundImage}
          style={{
            backgroundImage,
          }}
        />

        <div>
          {/* styles.headerBar */}
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12">
                <h1 className={styles.title} lang={lang}>
                  {params.get("title") || title}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              {items.map((item, idx) => {
                const prevItem = items[idx - 1];
                if (idx < InfoList.numItemsPerPage) {
                  return (
                    <InfoListItem
                      key={idx}
                      data={item}
                      prevItemData={prevItem}
                    />
                  );
                }
                return null;
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InfoList;



// WEBPACK FOOTER //
// ./src/components/InfoList/InfoList.js